jQuery(function ($) {
    if ($('#booking-tour-names').length === 0) {
        return;
    }
    $('#booking-tour-names #tourParticipantsNames').on('submit', function (e) {
        let names = [];
        e.preventDefault();
        $('#nameFields .namesRow').each(function (index) {
            let name = $(this).find('input[name^="names[' + index + ']"][name$="][\'firstname\']"]').val();
            let surname = $(this).find('input[name^="names[' + index + ']"][name$="][\'surname\']"]').val();

            names.push({
                name: name, surname: surname
            });
        });

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            dataType: 'JSON',
            data: {
                action: 'add-booking-participants-names',
                dummy_order_id: $('#dummy_order_id').val(),
                dummy_order_uuid: $('#dummy_order_uuid').val(),
                names: names
            },
            success: function (response) {
                if (response.success) {
                    $('#tourNamesMainRow').hide();
                    $('#tourParticipantsNames').hide();
                    $('#tourParticipantsNamesSuccess').show();
                }
            }
        });
    });
});